import {
  Component,
  Input,
  CUSTOM_ELEMENTS_SCHEMA,
  Output,
  EventEmitter,
  SimpleChanges,
  OnChanges,
} from '@angular/core';
import type { LeafModal } from '@cigna/leaf-web/lib/wc';
import '@cigna/leaf-web/lib/wc/components/modal/modal';

const OVERFLOW_HIDDEN_CLASS = 'overflow-hidden';

@Component({
  selector: 'cigna-leaf-modal',
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  template: `
    <leaf-modal
      [isActive]="isActive"
      [status]="status"
      [utilityModalTitle]="utilityModalTitle"
      [notDismissible]="notDismissible"
      [ariaLabel]="ariaLabel"
      [width]="width"
      (close-modal)="handleClose()"
      ><ng-content></ng-content><ng-content></ng-content
    ></leaf-modal>
  `,
})
export class CignaLeafModalComponent implements OnChanges {
  @Input() isActive: LeafModal['isActive'];
  @Input() status: LeafModal['status'];
  @Input() utilityModalTitle: LeafModal['utilityModalTitle'];
  @Input() notDismissible: LeafModal['notDismissible'];
  // @Input() modalTrigger: LeafModal['modalTrigger'];
  @Input() ariaLabel: LeafModal['ariaLabel'];
  @Input() width: LeafModal['width'];

  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onClose = new EventEmitter();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isActive']) {
      if (this.isActive) {
        document.body.classList.add(OVERFLOW_HIDDEN_CLASS); // Disable scrolling
      } else {
        document.body.classList.remove(OVERFLOW_HIDDEN_CLASS); // Enable scrolling
      }
    }
  }

  handleClose(): void {
    this.onClose.emit();
    document.body.classList.remove(OVERFLOW_HIDDEN_CLASS); // Ensure scrolling is enabled on close
  }
}
